module.exports = __webpack_public_path__ + "static/media/projeto.70910604.png";